import React, { Component } from "react";
import { DropdownItem, Badge, Button, Input } from "reactstrap";
import style from "./../Quotebar.module.scss";
import { FormattedDate, FormattedTime } from "react-intl";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import { getFieldVisibility, QuoteStatus, QuoteMode } from "./../../../utils/Quote/Quote";
import Form from "./Form";
import CircularProgress from "./../../CircularProgress/CircularProgress";
import { Icon } from "./Icon";
import { Status } from "./Status";
import { formattedNumber } from "../../FormattedNumber/FormattedNumber";

const spinnerStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  bottom: "30px",
  right: 0,
  margin: "auto",
};

const Item = ({ quote, openModalOrder, openModalOffer, isAdvisor, ...props }) => {
  const visibility = getFieldVisibility(quote);

  return (
    <div className={style.quote} style={props.loading ? { position: "relative" } : {}}>
      {props.loading && (
        <div className={style.loading}>
          <CircularProgress style={spinnerStyle} />
        </div>
      )}
      <div className={`message`}>
        <div className={style.icon}>
          <Icon quote={quote} isAdvisor={isAdvisor} />
        </div>
        <div>
          <small className="text-muted font-weight-bold" style={{ fontSize: "12px" }}>
            Quote request
          </small>
          <small className="text-muted float-right mt-1">
            <FormattedDate value={quote.AdvisorQuoteRequestedDate} />{" "}
            <FormattedTime value={quote.AdvisorQuoteRequestedDate} hour12={false} />
          </small>
        </div>

        <div className={style.detail}>
          {/* Side */}
          <div className="mr-2">
            <Badge color={quote.AdvisorQuoteIsBuy ? "buy" : "sell"} className={style.side}>
              {quote.AdvisorQuoteIsBuy ? "BUY" : "SELL"}
            </Badge>
          </div>
          {/* Symbol */}
          <div className="text-truncate mr-2">{quote.AssetTicker}</div>
          {/* Quantity */}
          <div className={style.quantity}>
            <div>
              <FormattedNumber value={parseFloat(quote.AdvisorQuoteQuantity)} dataTypeDecimalName="quantity" />
            </div>
            {quote.AdvisorQuoteStatus != QuoteStatus.WAITING && quote.AdvisorQuotePrice != null && (
              <div className={style.quantityPrice}>
                ${formattedNumber(quote.AdvisorQuotePrice, "price")}
              </div>
            )}
          </div>
        </div>

        <br />

        <div className={style.footer}>
          <div>
            {/* Sender / Receiver */}
            <div className="small text-muted text-truncate">
              {quote.AdvisorQuoteRequestedBy} {" / "} {quote.AdvisorQuoteRespondedBy}
            </div>

            <Status quote={quote} />
          </div>

          {/* Price */}
          {visibility.labelPrice && (
            <div className={style.price}>${formattedNumber(quote.AdvisorQuotePrice, null, "price")}</div>
          )}
        </div>

        <div className={style.form}>
          <Form
            {...props}
            quote={quote}
            isTrader={!isAdvisor}
            changeMode={props.changeMode}
            changeField={props.changeField}
            updateQuote={props.updateQuote}
            openModalOrder={openModalOrder}
            openModalOffer={openModalOffer}
          />
        </div>
      </div>
    </div>
  );
};

export default Item;
